import React from "react";
import { getStageMessage } from "./getStageMessage";
import "./meetingdetails.css";
import GetImage from "../../components/getimage/Getimage";
import getMeetingTime from "./utility/getMeetingTime";
import { getDateLabel } from "./utility/getDateLabel";
const Detailssection = ({ details, userID,meetingInfo }) => {
console.log(details,"meetingInfo")
  if (!details?.length) return null;


const groupedData = details.reduce((acc, item) => {
  const label = getDateLabel(item.logtime);

  if (!acc[label]) {
    acc[label] = [];
  }

  acc[label].push(item);
  return acc;
}, {});
  return (
    <div style={{height:"76vh" , overflowY:"auto" , paddingBottom:"6vh"}}>
    <div style={{marginTop:"20px"}}>
  {Object.keys(groupedData).map((dateLabel) => (
    <div key={dateLabel}>

     
      <div  style={{display:"flex", justifyContent:"center"}}>
        <p className="date-header" >
        {dateLabel}
            </p>
      </div>

     
      {groupedData[dateLabel].map((item, index) => {

        const stageData = getStageMessage({
          actionType: item?.actiontype,
          actionByEmpID: item?.actionbyempid,
          actionByEmpName: item?.actionbyempname,
          createdByEmpID: meetingInfo?.createdbyempid,
          createdByEmpName: meetingInfo?.createdbyempname,
          hostedByEmpID: meetingInfo?.hostempid,
          hostedByEmpName: meetingInfo?.hostempname,
          userID,
          data: item?.data,
          details:meetingInfo
        });

        return (
          <div key={index} className="detailsitem">

            <div className="image-row" style={{display:"flex", justifyContent:"center"}}>
              {stageData.leftImage && (
                <GetImage
                  imgID={stageData.leftImage}
                  width="40px"
                  height="40px"
                />
              )}

              {stageData.showRight &&
                stageData.rightImage &&
                stageData.rightImage != stageData.leftImage && (
                  <GetImage
                    imgID={stageData.rightImage}
                    width="40px"
                    height="40px"
                  />
                )}
            </div>

<div
  style={{
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  }}
>
  {/* Left line */}
  <div
    style={{
      position: "absolute",
      left: 0,
      right: "50%",
      borderTop: "1px solid #ff4d4f",
      marginRight: "80px",
    }}
  />

  {/* Message */}
  <div
    style={{
      color: "red",
      fontWeight: "500",
      whiteSpace: "nowrap",
      textAlign: "center",
      zIndex: 1,
      background: "white",
      padding: "0 8px",
    }}
    dangerouslySetInnerHTML={{ __html: stageData.message }}
  />

  {/* Right line */}
  <div
    style={{
      position: "absolute",
      left: "50%",
      right: "70px",
      borderTop: "1px solid #ff4d4f",
    }}
  />

  {/* Time */}
  <div
    style={{
      position: "absolute",
      right: 0,
      color: "gray",
      fontSize: "12px",
      whiteSpace: "nowrap",
      background: "white",
      padding: "0 5px",
    }}
  >
    {getMeetingTime(item.logtime.date)}
  </div>
</div>

          {item.actiontype==3  && (
  <div
  className="summarytest"
    dangerouslySetInnerHTML={{
      __html: item.data,
    }}
  />
)}
    


          </div>
        );
      })}
    </div>
  ))}
</div>


    </div>
  );
};

export default Detailssection;